
/*global define */
define('jsx!components/react-if/main',['jquery', 'underscore', 'react'], function($, _, React) {
    'use strict';
    return React.createClass({
        render: function() {
            if (this.props.condition) {
                return this.props.children;
            }
            else {
                return false;
            }
        }
    });
});
